module.exports = __webpack_public_path__ + "img/travel.d7d225ea.png";